export default {"src":"/_next/static/media/amenityIcon-av-equi.446cc8f0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};